<template>
  <b-jumbotron class="">
    <h1>{{ msg }}</h1>
  </b-jumbotron>
</template>

<script>
export default {
  name: 'NotFound',
  data() {
    return {
      msg: '404 - Page introuvable !',
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/pages/error/NotFound.vue